import moment from 'moment';
import stateManager from './user/stateManager';

class WelcomeNotificationModule {
  WELCOME_NOTIFICATION_KEY = 'shownWelcomeNotification';

  showWelcomeNotification = false;

  /**
   * Set the user state the time of first welcome notification shown
   */
  setWelcomeNotificationSeenState() {
    stateManager.getActionValue(this.WELCOME_NOTIFICATION_KEY)
      .then(timestamp => {
        if (!timestamp) {
          stateManager.addAction(this.WELCOME_NOTIFICATION_KEY, moment().toISOString());
          this.setWelcomeNotification = true;
        }
      });
  }

  /**
   * Add a welcome notification to pro notification feed if not shown
   */
  addWelcome(notifications, providerId) {
    return this.shouldShowWelcomeNotification().then(() => {
      if (this.showWelcomeNotification) {
        let creationTime = moment().toISOString();
        if (notifications.length) {
          creationTime = notifications[0].creation_time;
        }
        const welcomeNotification = {
          type: 'welcome',
          provider_id: providerId,
          creation_time: creationTime,
          uuid: 'welcome-notification',
          persistent: true,
        };
        notifications.unshift(welcomeNotification);
      }

      return notifications;
    });
  }

  /**
   * Check if the welcome notification has to be shown for the pro.
   */
  shouldShowWelcomeNotification() {
    return stateManager.getActionValue(this.WELCOME_NOTIFICATION_KEY).then(timestamp => {
      // Show the welcome notification for 3 days since the first shown day
      const showNotificationUntil = moment(timestamp).startOf('day').add(3, 'days');
      const today = moment().startOf('day');

      if (!timestamp || today.isBefore(showNotificationUntil)) {
        this.showWelcomeNotification = true;
      } else {
        this.showWelcomeNotification = false;
      }
    });
  }
}

const welcomeNotificationModule = new WelcomeNotificationModule();
export default welcomeNotificationModule;
